import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  SvgIconOwnProps,
} from '@mui/material';
import { memo } from 'react';
import { Link } from 'react-router-dom';

interface Props {
  title?: string;
  Icon: React.FC<SvgIconOwnProps>;
  isActive?: boolean;
  isExpanded?: boolean;
  link?: string;
  active?: boolean;
  onSelect?: (p: never) => void;
}

const PrimaryNavButton = ({
  title,
  Icon,
  isExpanded,
  link = '#',
  active,
  onSelect,
}: Props) => {
  return (
    <Link
      onClick={onSelect}
      to={link}
      style={{ textDecoration: 'none', color: 'initial' }}
    >
      <ListItem disablePadding sx={{ display: 'block' }}>
        <ListItemButton
          sx={{
            minHeight: 48,
            justifyContent: isExpanded ? 'initial' : 'center',
            px: 2.5,
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 0,
              mr: isExpanded ? 3 : 'auto',
              justifyContent: 'center',
            }}
          >
            {<Icon color={active ? 'primary' : 'inherit'} />}
          </ListItemIcon>
          <ListItemText
            primary={title}
            sx={{
              opacity: isExpanded ? 1 : 0,
              color: active ? '#2C74F6' : 'inherit',
            }}
          />
        </ListItemButton>
      </ListItem>
    </Link>
  );
};

export default memo(PrimaryNavButton);
